<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/clusters'"
            >Clusters</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <div style="display: flex; justify-content: space-between" class="col-10">
        <span
          class="col-3"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            color: gray;
          "
        >
          <i
            class="fa fa-filter"
            style="font-size: 15px; color: #8cc63f; margin-right: 5px"
          ></i>
          Filter
        </span>
        <span class="col-5">
          <input
            @change="filter()"
            v-model="keyword"
            type="text"
            class="form-control"
            placeholder="Keyword"
            style="padding: 10px"
          />
        </span>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="toggleCreateClusterModal()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">new cluster</p>
        </div>
      </div>
    </div>
    <spinner v-if="searchingClusters" />
    <pagination
      v-else
      @updateCluster="toggleUpdateClusterModal"
      @deleteCluster="deleteCluster"
      style="padding: 0 50px"
      :data="clustersPaginated"
      scope="props"
      itemTemplate="cluster"
      :classes="['clusterClass', 'col-12']"
    ></pagination>
    <div style="display: flex; padding: 0 50px">
      <div class="col-6">
        <md-card
          class="md-card-stats"
          style="
            background-color: white;
            border-radius: 15px;
            padding: 40px;
            height: 300px;
          "
        >
          <h5>Cluster Allocations</h5>

          <spinner style="margin-top: 60px" v-if="searchingClusters" />
          <pie-chart
            v-else
            style="height: 200px"
            :chart-data="pieChartData"
            :options="chartOptions"
          ></pie-chart>
        </md-card>
      </div>
      <div class="col-6">
        <md-card
          class="md-card-stats"
          style="
            background-color: white;
            border-radius: 15px;
            padding: 40px;
            height: 300px;
          "
        >
          <h5>Cluster Objective</h5>
          <spinner style="margin-top: 60px" v-if="searchingClusters" />

          <bar-chart
            v-else
            :style="barChartData.labels.length > 0 ? 'width: 100%;' : ''"
            style="height: 200px"
            :chart-data="barChartData"
            :labels="{
              x: {
                display: true,
              },
              y: {
                display: true,
              },
            }"
          ></bar-chart>
        </md-card>
      </div>
    </div>
    <cluster-modal
      :active="showClusterModal"
      :actionType="actionModalType"
      :activeCluster="activeCluster"
      @saveRequest="handleSave"
      @closeRequest="
        actionModalType == 'createModal'
          ? toggleCreateClusterModal()
          : toggleUpdateClusterModal()
      "
    />
  </div>
</template><script>
import ClustersFilter from "../../filters/ClustersFilter";
import ClusterModal from "./components/modals/clusterModal.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import Pagination from "../common/Pagination.vue";
import Spinner from "vue-simple-spinner";
import { PieChart, BarChart } from "../../components/ChartJS";

export default {
  name: "cluster",
  data() {
    return {
      selectedClusterId: null,
      actionModalType: null,
      showClusterModal: false,
      keyword: "",
      activeCluster: null,
      pieChartData: {
        labels: [],
        datasets: [],
      },
      barChartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "left",
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let dataset = data.datasets[tooltipItem.datasetIndex];
              let currentValue = dataset.data[tooltipItem.index];
              return (
                data.labels[tooltipItem.index] +
                " (" +
                currentValue +
                "%)"
              );
            },
          },
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
      },
    };
  },
  components: {
    ClusterModal,
    PieChart,
    BarChart,
    Pagination,
    Spinner,
  },
  created: function () {
    var clustersFilter = ClustersFilter();
    this.$store.dispatch("searchClusters", {
      filter: clustersFilter,
      resultMode: "paginated",
    });
  },
  computed: {
    // activeCluster() {
    //   // can be not array when paginated
    //   if (this.clusters && Array.isArray(this.clusters)) {
    //     return this.clusters.find((c) => c.id == this.selectedClusterId);
    //   }
    // },
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      clustersPaginated: (state) =>
        state.clusterStore.clusterSearch.clustersPaginated,
      createClusterStatus: (state) =>
        state.clusterStore.clusterCreate.createClusterStatus,
      updateClusterStatus: (state) =>
        state.clusterStore.clusterUpdate.updateClusterStatus,
      deleteClusterStatus: (state) =>
        state.clusterStore.clusterDelete.deleteClusterStatus,
      searchingClusters: (state) =>
        state.clusterStore.clusterSearch.searchingClusters,
    }),
  },
  methods: {
    init() {
      this.selectedClusterId = null;
      this.actionModalType = null;
      this.showClusterModal = false;
      var clustersFilter = ClustersFilter();
      this.$store.dispatch("searchClusters", {
        filter: clustersFilter,
        resultMode: "paginated",
      });
    },

    filter() {
      var clustersFilter = ClustersFilter();
      clustersFilter.text = this.keyword;
      this.$store.dispatch("searchClusters", {
        filter: clustersFilter,
        resultMode: "paginated",
      });
    },

    formValidation(cluster) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (!cluster.name) {
        missingFieldsString += "Cluster name is empty, ";
        result.isValid = false;
      }
      if (!cluster.description) {
        missingFieldsString += "Cluster description is empty, ";
        result.isValid = false;
      }
      if (!cluster.media_id) {
        missingFieldsString += "Cluster media is not selected, ";
        result.isValid = false;
      }

      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },

    handleSave(cluster) {
      const { isValid, message } = this.formValidation(cluster);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      if (this.actionModalType == "createModal") {
        this.createCluster(cluster);
      } else {
        this.updateCluster(cluster);
      }
    },
    createCluster(cluster) {
      this.$store.dispatch("createCluster", cluster);
    },
    updateCluster(cluster) {
      this.$store.dispatch("updateCluster", cluster);
    },
    deleteCluster(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this cluster?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteCluster", id);
        }
      });
    },
    toggleCreateClusterModal() {
      this.showClusterModal = !this.showClusterModal;
      this.showClusterModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdateClusterModal(cluster) {
      this.showClusterModal = !this.showClusterModal;
      if (this.showClusterModal) {
        this.actionModalType = "updateModal";
        this.activeCluster = cluster;
      } else {
        this.actionModalType = null;
        this.activeCluster = null;
      }
    },
  },
  watch: {
    clustersPaginated() {
      if (
        this.clustersPaginated.data &&
        this.clustersPaginated.data.length > 0
      ) {
        var labels = [];
        var data = [];
        this.clustersPaginated.data.forEach((cluster) => {
          labels.push(cluster.name);
          data.push(cluster.cluster_allocation_ratio.toFixed(2));
        });
        this.pieChartData.labels = labels;
        this.pieChartData.datasets = [
          {
            label: "Cluster Allocations",
            data: data,
            backgroundColor: [
              "#8cc63f",
              "rgb(255, 99, 132)",
              "rgb(54, 162, 235)",
              "rgb(255, 205, 86)",
              "rgb(32, 133, 236)",
              "rgb(114, 180, 235)",
              "rgb(10, 65, 122)",
              "rgb(132, 100, 160)",
              "rgb(206, 169, 188)",
              "rgb(50, 50, 50)",
              "rgb(223, 199, 49)",
              "rgb(234, 136, 216)",
              "rgb(17, 51, 103)",
              "rgb(151, 105, 142)",
              "rgb(186, 199, 193)",
              "rgb(60, 60, 60)",
            ],
            hoverOffset: 4,
          },
        ];
      }
    },
    createClusterStatus() {
      if (this.createClusterStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Cluster has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createClusterStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Cluster creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateClusterStatus() {
      if (this.updateClusterStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Cluster has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateClusterStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Cluster update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteClusterStatus() {
      if (this.deleteClusterStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Cluster has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteClusterStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Cluster delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.clusterClass {
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/clusters.vue